import React, { Component } from "react";

class FeaturesCompare extends Component {
  state = {
    accord_open: true,
  };
  toggle_state = (e) => {
    e.preventDefault();
    this.setState({
      accord_open: !this.state.accord_open,
    });
  };

 sentenceCase = (str) => {
  if (!str || typeof str !== 'string' || str == 'sst') return str;
  
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

formatNumberValue = (value) => {
  // Convert Indian number format (1,00,000) to US format (100,000)
  const convertIndianToUSFormat = (value) => {
    if (!value || typeof value !== 'string') return value;
    
    // Remove all commas first
    const numberWithoutCommas = value.replace(/,/g, '');
    
    // Check if it's a valid number
    if (isNaN(numberWithoutCommas)) {
      return value;
    }
    
    // Convert to number and back to string with US formatting
    const number = parseFloat(numberWithoutCommas);

    // Format with US comma separation (every 3 digits)
    const result = number.toLocaleString('en-US');    
    return result;
  };
  
  // Actually use the conversion function
  return convertIndianToUSFormat(value);
}

formatDisplayValue = (value) => {
  if (!value || typeof value !== 'string') return value;
  
  // Handle Unicode escape sequences dynamically
  let formattedValue = value;
  
  // Replace Unicode escape sequences with their actual characters
  formattedValue = formattedValue.replace(/\\u([0-9a-fA-F]{4})/g, (match, unicode) => {
    return String.fromCharCode(parseInt(unicode, 16));
  });
  
  // Handle specific Unicode patterns without backslash (like u2015, u00b0)
  const unicodeMap = {
    'u2015': '-',
    'u00b0': '°',
    'u2013': '–',
    'u2014': '—',
    'u00a0': ' ',
    'u2026': '…',
    'u00ae': '®',
    'u2122': '™',
    'u00a9': '©',
    'u00b1': '±',
    'u00d7': '×',
    'u00f7': '÷',
    'u2264': '≤',
    'u2265': '≥'
  };
  
  // Replace known Unicode patterns
  Object.keys(unicodeMap).forEach(unicodeKey => {
    const regex = new RegExp(unicodeKey, 'gi');
    formattedValue = formattedValue.replace(regex, unicodeMap[unicodeKey]);
  });
  
  if (formattedValue.toLowerCase().includes('defrost')) {
    return this.sentenceCase(formattedValue);
  }

  // Check if the value contains numbers with commas (any format)
  // This will catch both Indian (10,00,000) and US (1,000,000) formats
  if (/^\d+(?:,\d+)*(?:\.\d+)?$/.test(formattedValue.trim())) {
    return this.formatNumberValue(formattedValue);
  }

  // Check if it's a plain number without commas
  if(!isNaN(formattedValue)) {
    return this.formatNumberValue(formattedValue);
  }
  
  return formattedValue;
};

  render() {
    var ui_elements = <div />;
    let i = -1;
    if (typeof this.props.data != "undefined" && this.props.data.length > 0) {
      ui_elements = this.props.data.map((item, mainindex) => {
        i++;       
        var doe_values, a2l_values;
    
        // Handling DOE values
        if (typeof item.value.doe != "undefined" && item.value.doe.length > 0) {
          doe_values = item.value.doe.map((doe_item, index) => {
            if (!this.props.nochangelegacy) {
              return (
                <React.Fragment
                  key={
                    "doe" +
                    this.props.key +
                    (doe_item[this.props.selected_system] || "sample_doe") +
                    index +
                    "_" +
                    mainindex
                  }
                >
                  <li className="vs-li">&nbsp;</li>
                  <li>
                    <p>{doe_item[this.props.selected_system] ? this.formatDisplayValue(doe_item[this.props.selected_system]) : "-"}</p>
                  </li>
                </React.Fragment>
              );
            } else {
              if (index == 0) {
                return (
                  <React.Fragment
                    key={
                      "doe" +
                      this.props.key +
                      (doe_item[this.props.selected_system] || "sample_doe") +
                      index +
                      "_" +
                      mainindex
                    }
                  >
                    <li style={this.props.nochangelegacy ? { width: "65%" } : {}}>
                      <p>{doe_item[this.props.selected_system] ? this.formatDisplayValue(doe_item[this.props.selected_system]) : "-"}</p>
                    </li>
                  </React.Fragment>
                );
              } else {
                return <React.Fragment>{this.props.nochangelegacy}</React.Fragment>;
              }
            }
          });
        }
    
        //Handling A2L values
        let data;
        if(!this.props.state.isLegacyModel && this.props.a2l_data !== undefined) {
          data = this.props.a2l_data[i];
        }
        else {
          data = item;
        }

          if (typeof data.value.a2l != "undefined" && data.value.a2l.length > 0) {
          a2l_values = data.value.a2l.map((a2l_item, index) => {
            if (!this.props.nochangelegacy) {
              return (
                <React.Fragment
                  key={
                    "a2l" +
                    this.props.key +
                    (a2l_item[this.props.selected_system] || "sample_a2l") +
                    index +
                    "_" +
                    mainindex
                  }
                >
                  <li className="vs-li">&nbsp;</li>
                  <li>
                    <p>{a2l_item[this.props.selected_system] ? this.formatDisplayValue(a2l_item[this.props.selected_system]) : "-"}</p>
                  </li>
                </React.Fragment>
              );
            } else {
              if (index == 0) {
                return (
                  <React.Fragment
                    key={
                      "a2l" +
                      this.props.key +
                      (a2l_item[this.props.selected_system] || "sample_a2l") +
                      index +
                      "_" +
                      mainindex
                    }
                  >
                    <li style={this.props.nochangelegacy ? { width: "65%" } : {}}>
                      <p>{a2l_item[this.props.selected_system] ? this.formatDisplayValue(a2l_item[this.props.selected_system]) : "-"}</p>
                    </li>
                  </React.Fragment>
                );
              } else {
                return <React.Fragment>{this.props.nochangelegacy}</React.Fragment>;
              }
            }
          });
        }
    
        return (
          <ul
            key={"legacy" + this.props.key + item.value.legacy + mainindex}
            className="compare-list all-list compare-lis"
          >
            <li>
              <span>{item.key === "Selection Capacity" ? "Application Capacity" : item.key}</span>
            </li>
    
            <React.Fragment>
              {this.props.nochangelegacy ? (
                <React.Fragment />
              ) : (
                <li>
                  <p>{item.value.legacy[this.props.selected_system] ? this.formatDisplayValue(item.value.legacy[this.props.selected_system]) : "-"}</p>
                </li>
              )}
              {!this.props.state.showA2l && doe_values}
              {this.props.state.showA2l && a2l_values}
            </React.Fragment>
          </ul>
        );
      });
    }
    

    const button_type = this.state.accord_open
      ? "fa-minus-circle"
      : "fa-plus-circle";
    const visible = this.state.accord_open ? "block" : "none";
    return (
      <div>
        <div className="copare-list-heading">
          <strong>{this.props.title}</strong>
          <a href="#">
            <i
              onClick={this.toggle_state}
              className={"fa " + button_type}
              aria-hidden="true"
            />
          </a>
        </div>
        <div style={{ display: visible }}>{ui_elements}</div>
      </div>
    );
  }
}
export default FeaturesCompare;
